import type { Dict } from "../../i18n";

/** Shared react-hook-form validation rules for the auth forms, in the current language. */
export const emailRules = (t: Dict) => ({
  required: t.auth.rules.emailRequired,
  pattern: {
    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    message: t.auth.rules.emailInvalid,
  },
});

export const phoneRules = (t: Dict) => ({
  required: t.auth.rules.phoneRequired,
  pattern: {
    value: /^\+?[0-9\s.-]{9,}$/,
    message: t.auth.rules.phoneInvalid,
  },
});

export const newPasswordRules = (t: Dict) => ({
  required: t.auth.rules.passwordRequired,
  minLength: { value: 8, message: t.auth.rules.passwordMin },
  pattern: {
    value: /^(?=.*[A-Za-z])(?=.*\d).+$/,
    message: t.auth.rules.passwordPattern,
  },
});

export const required = (message: string) => ({
  required: message,
  validate: (v: string) => v.trim() !== "" || message,
});
